import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import {ACTIVITY_TYPE} from "../../../../common/Constants";

class MasterHadiahModifying extends Component {
    qrOptions = [
        {
            label: "YES",
            value: true,
        },
        {
            label: "NO",
            value: false,
        },
    ];

    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    render() {
        return (
            <SimpleModal
                title="Form Hadiah"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <SimpleInput
                                id="input_text_kode_hadiah"
                                name="kodeHadiah"
                                label="Kode Hadiah"
                                readOnly={this.props.activityType === ACTIVITY_TYPE.UPDATE}
                                mandatory
                                errorMessage={this.props.errors.kodeHadiah}
                                value={this.props.controls.kodeHadiah.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_nama_hadiah"
                                name="nameHadiah"
                                label="Nama Hadiah"
                                mandatory
                                errorMessage={this.props.errors.nameHadiah}
                                value={this.props.controls.nameHadiah.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_kategori"
                                box="search"
                                name="categoryHadiah"
                                label="Kategori"
                                mandatory
                                isClearable
                                errorMessage={this.props.errors.categoryHadiah}
                                options={this.props.dataKategoriDDL}
                                value={this.props.controls.categoryHadiah.value}
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_qrcode"
                                box="search"
                                name="qrHadiah"
                                label="QR Code"
                                mandatory
                                isClearable
                                errorMessage={this.props.errors.qrHadiah}
                                options={this.qrOptions}
                                value={this.props.controls.qrHadiah.value}
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_satuan"
                                box="search"
                                name="satuanHadiah"
                                label="Satuan"
                                mandatory
                                isClearable
                                errorMessage={this.props.errors.satuanHadiah}
                                options={this.props.dataSatuanDDL}
                                value={this.props.controls.satuanHadiah.value}
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <div style={{textAlign: "center"}}>
                                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                            </div>
                    </ModalContainer>
                }
            />
        );
    }
}

export default withFormGroup(MasterHadiahModifying);